<template>
  <div @click="select" class="base-area" v-bind:class="{ active: imgActive }">
    <div>
      <input
        class="form-control el-name"
        type="text"
        placeholder="image name"
        :value="value.img_name"
        @input="updateImageName($event.target.value)"
      />
    </div>
    <div class="image-area">
      <img class="small-image" :src="imageView(value.image)" />
      <div>
        <b-icon-x-circle
          class="delete-button"
          aria-hidden="true"
          @click="deleteClick"
        ></b-icon-x-circle>
      </div>
    </div>
    <div class="freq">
      {{ $t("FRE") }} {{ Math.floor(value.parts_probability * 100) / 100 }}%
    </div>
  </div>
</template>
<script>
import { i18n } from "../lang";

export default {
  name: "SmallImage",
  props: ["value"],
  mounted() {
    this.deleteFlag = false;
  },
  data() {
    return {
      cuurentImg: "",
      currentName: "",
      deleteFlag: false,
      imgActive: false,
    };
  },
  methods: {
    deleteClick() {
      this.deleteFlag = true;
    },
    imageView(image) {
      return `data:image/png;base64,${image}`;
    },
    select(event) {
      if (this.deleteFlag === true) {
        var self = this;
        this.$bvModal
          .msgBoxConfirm(i18n.t("PART"))
          .then((value) => {
            if (value === true) {
              this.$emit("click", {
                image_id: self.value.image_id,
                img_name: self.value.img_name,
                file_name: self.value.file_name,
                parts_probability: self.value.parts_probability,
                image: self.value.image,
                deleteFlag: self.deleteFlag,
              });
            } else {
              self.deleteFlag = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.imgActive = true;
        this.$emit("click", {
          image_id: this.value.image_id,
          img_name: this.value.img_name,
          file_name: this.value.file_name,
          parts_probability: this.value.parts_probability,
          image: this.value.image,
          deleteFlag: this.deleteFlag,
        });
      }
    },
    updateImageName(img) {
      this.$emit("input", {
        image_id: this.value.image_id,
        img_name: img,
        file_name: this.value.file_name,
        parts_probability: this.value.parts_probability,
        image: this.value.image,
        deleteFlag: this.deleteFlag,
      });
    },
    setImageActive(value) {
      this.imgActive = value;
    },
  },
};
</script>
<style scoped>
.base-area {
  /* margin-left: 10px; */
}
.image-area {
  position: relative;
}
.delete-button {
  width: 14;
  height: 14;
  color: #ffffff;
  background-color: #0000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 115px;

  position: absolute;
  top: 0;
  left: 0;
}
.freq {
  width: 140px;
  height: 23px;
  background: #575656 0% 0% no-repeat padding-box;
  border: 1px solid #e0e0e0;
  color: #ffffff;
  opacity: 1;
  font: normal normal 600 13px/18px Noto Sans;
}
.small-image {
  width: 140px;
  height: 140px;
}
.el-name {
  width: 140px;
  height: 23px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e0e0e0;
  opacity: 1;
  border-radius: 0px;
}
.el-name-icon {
  height: 16px;
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/SmallImage.vue